import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  Z_INDEXS
} from '../../../themes'
export const StyleModal = styled.div`

  .data-list {
    padding: 10px 16px;
    z-index: ${Z_INDEXS.LV_10};
  }

  .card {
    background: white;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 410px;
    height: auto;
    padding: 15px;
  }

  .action-button {
    text-align: right;

    img {
      margin-left: 30px;
      cursor: pointer;
    }
  }

  .more_content_delete {
    position: absolute;
    right: 30px;
    top: 28px;
  }

  .title {
    margin-top: 8px;
    white-space: nowrap;
    display: flex;
    align-items: center;

    span {
      margin-left: 16px;
      text-align: left;
      font-family: NunitoSansBold;
      font-size: ${FONT_SIZE.MD};
      color: ${COLOR.BLACK_1};
    }
  }

  .two-lines {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 16px;
    text-align: left;
    font-family: NunitoSansBold;
    width: 90%;
    color: ${({ colorTheme }) => colorTheme ? `${colorTheme}` : COLOR.GOLD_1};
    }

  .link-icon {
    text-decoration: none;
    color: ${({ colorTheme }) => colorTheme ? `${colorTheme}` : COLOR.GOLD_1};
    }

  .copy-link-button {
    padding: 0;
    background-color: unset;
    border: unset;
    cursor: pointer;
  }

  .detail {
    margin-top: 8px;
    white-space: nowrap;
    display: flex;
    align-items: center;

    > img {
      width: 16px;
    }

    span {
      width: 374px;
      height: auto;
      white-space: normal;
      margin-left: 16px;
      text-align: left;
      font-family: NunitoSansRegular;
      font-size: ${FONT_SIZE.XXS};
      color: ${COLOR.BLACK_1};
    }

    &__repeat {
      width: 374px;
      white-space: break-spaces;
    }
  }

  .card_more {
    background: white;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    width: 240px;
    height: auto;
    padding: 15px;
  }

  .day_more {
    text-align: center;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.XXS};
    letter-spacing: 0;
    color: ${COLOR.BLACK_1};
    opacity: 1;
  }

  .day_more_number {
    text-align: center;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.LG2};
    letter-spacing: 0;
    color: ${COLOR.BLACK_1};
    opacity: 1;
  }

  .title_more {
    cursor: pointer;
    white-space: nowrap;
    padding: 3px;
    display: flex;
    align-items: center;
  }

  .title_more:hover {
    background: ${COLOR.PEARL};
  }

  .alive {
    border-radius: 4px;
    background: ${({ colorTheme }) => colorTheme ? `${colorTheme}a0` : COLOR.GOLD_1};
  }
  .alive:hover {
    background: ${({ colorTheme }) => colorTheme ? `${colorTheme}a0` : COLOR.GOLD_1};
  }

  .alive > .sub_title_more {
    color: ${COLOR.BLACK_1};
  }

  .size_bullet {
    color: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
    font-size: 1.5em;
    top: 11px;
    position: relative;
  }

  .title_year {
    text-align: left;
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.MD};
    letter-spacing: 0;
    color: ${COLOR.BLACK_1};
    opacity: 1;
  }

  .sub_title_more {
    margin-left: 8px;
    text-align: left;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.MN};
    letter-spacing: 0;
    color: ${COLOR.BLACK_1};
  }

  .data-list-year {
    margin-top: 20px;
    overflow-Y: scroll;
    display: 'block';
  }

  .list-year {
    white-space: nowrap;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-top: 8px;
    display: flex;
    align-items: center;
  }

  .list-year:hover {
    background: ${COLOR.PEARL};
    cursor: pointer;
  }

  .sub_title_year {
    text-align: left;
    font-family: Nunito;
    font-size: ${FONT_SIZE.XXS};
    letter-spacing: 0;
    color: ${COLOR.BLACK_1};
    margin-left: 15px;
  }

  .list_more {
    height: 130px;
    width: 200px;
    overflow-y: scroll;
    overflow-x: hidden;
    display: block;
  }

  .bullet {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${COLOR.GOLD_1};
  }

  .view-booking__button {
    width: 100%;
    margin-top: 8px;

    button {
      width: 100%;
      border: 0;
      font-family: NunitoRegular;
      font-size: ${FONT_SIZE.XXS};
      padding: 8px 20px;
      border-radius: 4px;
      background-color: ${COLOR.GOLD_1};
    }
  }
`
